import { Alert, Box, Button, TextField, Typography } from '@mui/material'
import { useState } from 'react'
import { verifySenderName } from '@/services/notificationService'

// Provider charset (confirmed against the provider console 2026-07-14):
// English letters/digits/+/-/space. Names only, max 11 chars — the provider
// also accepts 972-prefixed phone-style senders with no length cap, but
// product policy (2026-07-15) forbids phone-style sender names, so no
// exemption here.
const SENDER_CHARSET_RE = /^[a-zA-Z0-9+\- ]*$/

export const isValidSenderName = (raw: string): boolean => {
  const value = raw.trim()
  if (!value || !SENDER_CHARSET_RE.test(value)) return false
  return value.length <= 11
}

type Props = { accountId: number; currentName: string | null }

const SenderNameSettings = ({ accountId, currentName }: Props) => {
  const [name, setName] = useState(currentName ?? '')
  const [busy, setBusy] = useState(false)
  const [result, setResult] = useState<{
    approved: boolean
    providerResponse: string
  } | null>(null)

  const valid = isValidSenderName(name)

  const verify = async () => {
    setBusy(true)
    setResult(null)
    try {
      setResult(await verifySenderName(accountId, name.trim()))
    } catch {
      setResult({ approved: false, providerResponse: 'הבדיקה נכשלה — נסו שוב' })
    } finally {
      setBusy(false)
    }
  }

  return (
    <Box
      sx={{
        direction: 'rtl',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        maxWidth: 420,
      }}
    >
      <Typography variant="subtitle2">שם השולח (SMS)</Typography>
      <TextField
        value={name}
        onChange={e => {
          setName(e.target.value)
          setResult(null)
        }}
        placeholder="RimonimTech"
        helperText="עד 11 תווים — אותיות באנגלית, ספרות, רווחים, + או -"
        error={name.length > 0 && !valid}
      />
      <Button onClick={verify} disabled={busy || !valid}>
        {currentName ? 'בדיקה חוזרת' : 'אימות ושמירה'}
      </Button>
      {result?.approved && <Alert severity="success">השם אושר ונשמר</Alert>}
      {result && !result.approved && (
        <Alert severity="error">{result.providerResponse}</Alert>
      )}
    </Box>
  )
}

export default SenderNameSettings
